// extracted by mini-css-extract-plugin
export var active = "_87-a";
export var activeIndicator = "_87-8";
export var animate = "_87-9";
export var disabled = "_87-b";
export var fullWidth = "_87-2";
export var lg = "_87-7";
export var md = "_87-6";
export var redoButtonTabGroup = "_87-0";
export var sm = "_87-5";
export var tabButton = "_87-3";
export var tabButtonsContainer = "_87-1";
export var xs = "_87-4";